/*
 * IRIS Interactive
 *
 * NOTICE OF LICENSE
 *
 * This source file is no subject to a specific license
 * but it belongs to the company IRIS Interactive.
 * You can contact IRIS Interactive at the following
 * address: contact@iris-interactive.fr
 *
 * @author      Lucas ROCHE
 * @date        30/12/2021 14:50
 * @copyright   Copyright (c) 2002-2021 IRIS Interactive, Inc. (http://www.iris-interactive.fr)
 */

import Swiper from '@iris.interactive/handcook/public/scripts/libraries/swiper-11'

export default class HeaderSlider {
    slider

    // HTML Element
    trigger = '[data-hc-trigger="slider"]'
    item = '[data-hc-element="slider-item"]'

    constructor() {
        $(this.trigger).each((index) => {
            this.slider = $($(this.trigger)[index])
            this.buildDom()
        })

        Swiper.create('#header-banner-slider', {
            slidesPerView: 1,
            spaceBetween: 0,
            mousewheel: {
                forceToAxis: true,
            },
            freeMode: {
                enabled: true,
                sticky: true,
            },
            pagination: {
                el: '.header__heading__pagination',
                type: 'bullets',
                clickable: true,
            },
            grabCursor: true,
            speed: 600,
            lazy: true,
            autoplay: {
                delay: 5000,
            },
        }).then((slider) => {
            const pagination = $('.header__heading__pagination')

            if ($(pagination).length > 0) {
                //Init active cursor
                $(pagination).append('<span class="swiper-pagination-bullet-active-cursor"></span>')
                const cursor = $(pagination).find('.swiper-pagination-bullet-active-cursor')
                let bullet_pos = $(pagination)
                    .find('.swiper-pagination-bullet-active')
                    .position().left
                $(cursor).css('left', bullet_pos + 10)
                $(cursor).css('opacity', 1)

                //Anim on change
                slider.on('slideChange', () => {
                    bullet_pos = $(pagination)
                        .find('.swiper-pagination-bullet-active')
                        .position().left
                    $(cursor).css('left', bullet_pos + 10)
                })

                //Anim on resize
                $(window).on('resize', () => {
                    bullet_pos = $(pagination)
                        .find('.swiper-pagination-bullet-active')
                        .position().left
                    $(cursor).css('left', bullet_pos + 10)
                })
            }
        })
    }

    buildDom() {
        // On recupère les slide items (element de DOM enfant de premier niveau)
        // et on leur ajoute la classe des slide item
        const items = this.slider.children('[data-item="slide"]')
        items.addClass('swiper-slide')

        // On ajoute la classe swiper a notre slider,
        // on crée la div wrapper et on insére les slider item dedans
        this.slider.addClass('swiper')
        this.slider.append('<div class="swiper-wrapper"></div>')
        this.slider.find('.swiper-wrapper').append(items)
    }
}
